































import { Component, Prop, Vue } from "vue-property-decorator";
import { CrudService } from "../../core/services/crudService";
import { Settings } from "../../core/services/configService";
import { CustomerHelper } from "../../crm/helpers/customerHelper";
import { ProgramPackTexts } from "../../bookings/programPackTexts";
import ProgramPanel from "./ProgramPanel.vue";

@Component({
  components: { ProgramPanel },
})
export default class ProgramEvolution extends Vue {
  @Prop({ type: Object, required: true }) enrollment!: any;
  surveys: any[] = [];
  results: any[] = [];
  chart = { width: 600, height: 200, pad: 40, top: 30, bottom: 30 };

  y(score: number): number {
    return this.chart.top + (100 - score) / 100 * (this.chart.height - this.chart.top - this.chart.bottom);
  }

  async mounted() {
    const customerId = CustomerHelper.getStoredCustomer();
    const service = new CrudService();
    const [scores, tests] = await Promise.all([
      service.httpGet(`${Settings.HostName}/api/publiccustomersurveys/customer-scores/${customerId}`),
      service.httpGet(`${Settings.HostName}/api/publictestresults/customer/${customerId}`),
    ]);
    this.surveys = this.groups(scores && scores.ok ? scores.model : [], (s: any) => s.survey, (s: any) => s.answeredDate).map((g) => {
      const step = (this.chart.width - 2 * this.chart.pad) / Math.max(g.items.length - 1, 1);
      const first = Math.round(g.items[0].score);
      const last = Math.round(g.items[g.items.length - 1].score);
      return {
        name: g.name,
        summary: this.$t("From {0} to {1} out of 100").toString().replace("{0}", String(first)).replace("{1}", String(last)),
        points: g.items.map((s: any, i: number) => ({
          x: g.items.length > 1 ? this.chart.pad + i * step : this.chart.width / 2,
          y: this.y(s.score),
          score: Math.round(s.score),
          date: ProgramPackTexts.date(s.answeredDate, false),
        })),
      };
    });
    this.results = this.groups(tests && tests.ok ? tests.data : [], (r: any) => r.parameter, (r: any) => r.date).map((g) => {
      const items = g.items.length > 1 ? [g.items[0], g.items[g.items.length - 1]] : g.items;
      return {
        name: g.name,
        reference: items[items.length - 1].referenceRange,
        value: `${items.map((r: any) => r.amount).join(" → ")} ${items[0].unitsLabel || ""}`,
      };
    });
    this.$emit("loaded", !!this.enrollment.conclusions || this.surveys.length + this.results.length > 0);
  }

  groups(rows: any[], name: (row: any) => string, date: (row: any) => string): { name: string; items: any[] }[] {
    const from = new Date(this.enrollment.startDate).getTime();
    const to = this.enrollment.expiresAt ? new Date(this.enrollment.expiresAt).getTime() : Infinity;
    const byName: { [key: string]: any[] } = {};
    rows
      .filter((row) => new Date(date(row)).getTime() >= from && new Date(date(row)).getTime() <= to)
      .sort((a, b) => new Date(date(a)).getTime() - new Date(date(b)).getTime())
      .forEach((row) => (byName[name(row)] = (byName[name(row)] || []).concat(row)));
    return Object.keys(byName).map((key) => ({ name: key, items: byName[key] }));
  }
}
